import { useAnalytics, useAuthentication, captureObservabilityError } from '@psyomics/ui-common';
import { useEffect, useRef } from 'react';

import { useReferralInviteQuery } from '../../referral/hooks/use-referral-invite-query';

export const useQuestionnaireStartTracking = (invitePublicId: string) => {
  const analytics = useAnalytics();
  const { authSystemId } = useAuthentication();
  const [invite, , error] = useReferralInviteQuery(invitePublicId);

  const organisationCode = invite?.referralSession?.referral?.organisation?.code;
  const serviceCode = invite?.referralSession?.referral?.service?.code;

  const hasTracked = useRef(false);

  useEffect(() => {
    if (error) {
      captureObservabilityError(
        `Referral invite query failed for invite public id ${invitePublicId}: ${error.message}`
      );
    }
  }, [error, invitePublicId]);

  useEffect(() => {
    if (!authSystemId || hasTracked.current) return;
    hasTracked.current = true;

    if (organisationCode) {
      analytics.setGroup({
        groupType: 'organisation',
        groupKey: organisationCode,
      });
    } else {
      captureObservabilityError(`Missing organisation code for posthog group ${invitePublicId}`);
    }

    analytics.trackEvent({
      event: 'questionnaire_started',
      properties: {
        invite: invitePublicId,
        ...(serviceCode && { service: serviceCode }),
      },
      captureOptions: {
        $set: {
          ...(invitePublicId && { current_invite: invitePublicId }),
          ...(serviceCode && { current_service: serviceCode }),
        },
      },
    });
  }, [analytics, authSystemId, invitePublicId, serviceCode, organisationCode]);
};
